import { render, staticRenderFns } from "./ProductInfoItem.vue?vue&type=template&id=13b8e74e&scoped=true&"
import script from "./ProductInfoItem.vue?vue&type=script&lang=js&"
export * from "./ProductInfoItem.vue?vue&type=script&lang=js&"
import style0 from "./ProductInfoItem.vue?vue&type=style&index=0&id=13b8e74e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b8e74e",
  null
  
)

export default component.exports